export default axios => ({
  getList (payload) {
    return axios.get('/doctor', payload)
  },
  getItem (id) {
    return axios.get(`/doctor/${id}`)
  },
  post (payload) {
    return axios.post('/doctor', payload)
  },
  update (id, payload) {
    return axios.patch(`/doctor/${id}`, payload)
  },
  delete (id) {
    return axios.delete(`/doctor/${id}`)
  },
  create (payload) {
    return axios.post('/doctor', payload)
  }
})
